module.exports = __webpack_public_path__ + "static/img/land32.5fdd294.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/land32.svg
// module id = UqW4
// module chunks = 0